import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ConservazioneCaricaDocumentoLulStep2Component } from './conservazione-carica-documento-lul-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.conservazione-carica-documento-lul-step2', {
            url: '/conservazione-carica-lul',
            ncyBreadcrumb: {
                label: 'Carica LUL',
                parent: 'home.conservazione'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Conservazione Carica Documento'
            },
            'views': {
                'homeContent': {
                    template: '<conservazione-carica-documento-lul-step2 flex="100"></conservazione-carica-documento-lul-step2>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoLulStep2Module: string = ng
    .module('conservazione-carica-documento-lul-step2', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('conservazioneCaricaDocumentoLulStep2', ConservazioneCaricaDocumentoLulStep2Component)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-lul-step2/conservazione-carica-documento-lul-step2.module.ts